<template>
  <FormDate
    class="text-slate-900"
    :model-value="date"
    :name="name"
    hide-timezone
    year-month-date-only
    @update:modelValue="updateAnswer"
  />
</template>

<script setup>
import FormDate from "./FormDate.vue";
import {ref, watch} from "vue";

const emits = defineEmits(["update:answer"]);
const props = defineProps({
  question: Object,
  answer: Object,
  name: [String, Number],
});

const date = ref(props.answer?.answer);

const updateAnswer = (value) => {
  emits("update:answer", {value});
  date.value = value;
};

watch(() => props.answer, (newAnswer) => {
  date.value = newAnswer?.answer;
});
</script>
